export class PageLoaderError extends Error {
  constructor(cause: string) {
    super(
      'PageLoader cant continue because targetPagePropsLoader didnt return a valid result',
      { cause },
    );
  }
}
